import { api } from '../rest';

const listAlerts = async () => {
  const { data } = await api.get('/alert');
  return data;
};

export default { listAlerts };
